import { Flex, Input, TextArea } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

interface NameSectionProps {
  nameValue: string | undefined;
  descriptionValue: string | undefined;
  errorStatus: string | undefined;
  handleInputChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
      | React.MouseEvent<HTMLButtonElement>,
    value: string
  ) => void;
}

export const NameSection = ({
  nameValue,
  descriptionValue,
  errorStatus,
  handleInputChange
}: NameSectionProps) => {
  return (
    <Flex gap={"4px"} direction={"column"}>
      <Input
        label={appstr("Name")}
        name={"name"}
        placeholder={appstr("Name")}
        size={"medium"}
        value={nameValue}
        onChange={handleInputChange}
        status={errorStatus ? "error" : "default"}
        message={errorStatus}
        dataTestId="rls-name-input"
      />
      <TextArea
        label={appstr("Description")}
        name={"description"}
        placeholder={appstr("Description")}
        size={"medium"}
        value={descriptionValue}
        onChange={handleInputChange}
        dataTestId="account-settings-security-rls-description-textarea"
      />
    </Flex>
  );
};
